<template>
  <el-col class="chart-module" :lg="12" v-loading="loading">
    <div class="sub-view">
      <el-row>
        <span style="font-weight: bold">{{ displayTitle }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.onClose(title)"
        ></i>
        <i class="el-icon-zoom-in" v-else @click="showPopUp()"></i>
      </el-row>
      <el-row>
        <el-select
          v-model="period"
          @change="periodChange('main')"
          style="width: 30%; padding: 0; float: right"
        >
          <el-option
            v-for="item in periodOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-row>
      <hr />
      <el-row>
        <echarts
          :autoresize="true"
          class="chart-view"
          :option="option"
          @click="onClick"
        />
      </el-row>
      <el-dialog
        :visible.sync="popUpDisplay"
        :append-to-body="true"
        class="historyDailog"
      >
        <template slot="title">
          <el-row>
            <span style="font-weight: bold">{{ displayTitle }}</span>
          </el-row>
          <el-row>
            <el-select
              v-model="period"
              @change="periodChange('popup')"
              style="width: 30%; padding: 0; float: right"
            >
              <el-option
                v-for="item in periodOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-row>
        </template>
        <hr />
        <echarts
          :autoresize="true"
          :option="option"
          style="height: 75vh"
          v-loading="popupLoading"
          @click="onClick"
        />
      </el-dialog>
    </div>
  </el-col>
</template>
 
<script>
import api from "@/api";
var moment = require("moment-timezone");
export default {
  name: "ResponseTypeCountChart",
  props: ["title", "displayTitle"],
  data() {
    return {
      periodOptions: [
        {
          value: "①過去3ヶ月間の同月比",
          label: "①過去3ヶ月間の同月比",
        },
        {
          value: "②過去12ヶ月間の同月比",
          label: "②過去12ヶ月間の同月比",
        },
        {
          value: "③過去3年間の同月比",
          label: "③過去3年間の同月比",
        },
        {
          value: "④過去3年間の同年比",
          label: "④過去3年間の同年比",
        },
      ],
      period: "②過去12ヶ月間の同月比",
      endDate: this.$root.endDate,
      option: {},
      loading: false,
      popupLoading: false,
      popUpDisplay: false,
      responseTypeColors: {
        'AIチャットボット応対': '#91d5ff',
        'AIボイスボット応対': '#69c0ff',
        '電話モード応対': '#40a9ff',
        'チャットモード応対': '#1890ff',
        'F2Fモード応対': '#096dd9'
      }
    };
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.$bus.$on("changeEndMonth", (startDate, endDate) => {
      this.endDate = endDate;
      this.periodChange("main");
    });
  },
  methods: {
    loadData() {
      let self = this;
      self.loading = true;
      api.getResponseTypeCount(
        this.period,
        this.endDate,
        self.$root.facetForEchart,
        self.$root.ageForEchart,
        self.$root.sexForEchart
      ).then(
        (res) => {
          let data = res.data;
          
          // Build chart option
          self.option = {
            title:{
              // subtext: "件"
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              },
              formatter: function(params) {
                let result = params[0].name + '<br/>';
                let total = 0;
                params.forEach(item => {
                  total += item.value;
                });
                params.forEach(item => {
                  let percent = ((item.value / total) * 100).toFixed(1);
                  result += item.marker + item.seriesName + ': ' + 
                           item.value.toLocaleString() + ' (' + percent + '%)<br/>';
                });
                return result;
              }
            },
            legend: {
              data: data.legend,
              top: 2
            },
            grid: {
              left: '5%',
              right: '5%',
              bottom: '10%',
              top: 90,
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: data.months
            },
            yAxis: {
              type: 'value',
              name: '件'
            },
            series: data.series.map(item => ({
              name: item.name,
              type: 'bar',
              stack: 'total',
              data: item.data,
              barWidth: "50%",
              itemStyle: {
                color: self.responseTypeColors[item.name] || '#1890ff'
              }
            }))
          };
          
          self.loading = false;
        },
        (err) => {
          console.log(err);
          self.loading = false;
        }
      );
    },
    showPopUp() {
      this.popUpDisplay = true;
    },
    periodChange(type) {
      if (type === 'main') {
        this.loadData();
      } else {
        this.popupLoading = true;
        this.loadData();
        this.popupLoading = false;
      }
    },
    onClick(params) {
      // Calculate date range from clicked month
      let startDate = "";
      let endDate = "";
      
      if (params.name.length > 8) {
        // Format: "2019年11月~2020年1月"
        startDate = moment(
          params.name.split("~")[0].replace("年", "-").replace("月", "")
        )
          .startOf("month")
          .format("YYYY-MM-DD");
        endDate = moment(
          params.name.split("~")[1].replace("年", "-").replace("月", "")
        )
          .endOf("month")
          .format("YYYY-MM-DD");
      } else if (params.name.length < 8) {
        // Format: "11月"
        let baseEndDate = this.endDate.substring(5, 7);
        if (Number(params.name.replace("月", "")) <= Number(baseEndDate)) {
          startDate = moment(
            this.endDate.substring(0, 4) + "-" + params.name.replace("月", "")
          )
            .startOf("month")
            .format("YYYY-MM-DD");
          endDate = moment(
            this.endDate.substring(0, 4) + "-" + params.name.replace("月", "")
          )
            .endOf("month")
            .format("YYYY-MM-DD");
        } else {
          let baseYear = Number(this.endDate.substring(0, 4)) - 1;
          startDate = moment(baseYear + "-" + params.name.replace("月", ""))
            .startOf("month")
            .format("YYYY-MM-DD");
          endDate = moment(baseYear + "-" + params.name.replace("月", ""))
            .endOf("month")
            .format("YYYY-MM-DD");
        }
      } else {
        // Format: "2020年10月"
        startDate = moment(params.name.replace("年", "-").replace("月", ""))
          .startOf("month")
          .format("YYYY-MM-DD");
        endDate = moment(params.name.replace("年", "-").replace("月", ""))
          .endOf("month")
          .format("YYYY-MM-DD");
      }

      // Build age and sex filter string
      let ageAndSexStr = '';
      if (this.$root.ageForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_89&op%5Bcf_89%5D=~&v%5Bcf_89%5D%5B%5D=" + this.$root.ageForEchart[0];
      }
      if (this.$root.sexForEchart != '') {
        ageAndSexStr += "&f%5B%5D=cf_90&op%5Bcf_90%5D=~&v%5Bcf_90%5D%5B%5D=" + this.$root.sexForEchart[0];
      }

      // Build Redmine URL based on response type
      let redmineUrl = this.$root.redmineUrl + "/projects/aicc-redmine/issues?utf8=%E2%9C%93&set_filter=1&sort=id%3Adesc&f%5B%5D=status_id&op%5Bstatus_id%5D=c&f%5B%5D=created_on&op%5Bcreated_on%5D=%3E%3C&v%5Bcreated_on%5D%5B%5D=" +
        startDate + "&v%5Bcreated_on%5D%5B%5D=" + endDate;

      // Add tracker and mode filters based on response type
      if (params.seriesName === "AIチャットボット応対") {
        redmineUrl += "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=2";
      } else if (params.seriesName === "チャットモード応対") {
        redmineUrl += "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=cf_45&op%5Bcf_45%5D=%3D&v%5Bcf_45%5D%5B%5D=chat";
      } else if (params.seriesName === "電話モード応対") {
        redmineUrl += "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=cf_45&op%5Bcf_45%5D=%3D&v%5Bcf_45%5D%5B%5D=telephone";
      } else if (params.seriesName === "F2Fモード応対") {
        redmineUrl += "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=cf_45&op%5Bcf_45%5D=%3D&v%5Bcf_45%5D%5B%5D=f2f";
      } else if (params.seriesName === "AIボイスボット応対") {
        redmineUrl += "&f%5B%5D=tracker_id&op%5Btracker_id%5D=%3D&v%5Btracker_id%5D%5B%5D=1&f%5B%5D=cf_45&op%5Bcf_45%5D=%3D&v%5Bcf_45%5D%5B%5D=voicebot";
      }

      // Add category filter if facet is set
      if (this.$root.facetForEchart && this.$root.facetForEchart.length > 0) {
        redmineUrl += "&f%5B%5D=cf_22&op%5Bcf_22%5D=%7E&v%5Bcf_22%5D%5B%5D=" + this.$root.facetForEchart[0];
      }

      // Add standard columns and age/sex filters
      redmineUrl += "&f%5B%5D=&c%5B%5D=tracker&c%5B%5D=cf_45&c%5B%5D=cf_3&c%5B%5D=category&c%5B%5D=cf_22&c%5B%5D=subject&c%5B%5D=cf_37&c%5B%5D=cf_80&c%5B%5D=assigned_to&c%5B%5D=created_on&c%5B%5D=status&c%5B%5D=cf_43&group_by=&t%5B%5D=" + ageAndSexStr;

      window.open(redmineUrl);
    }
  },
};
</script>
 
<style scoped>
.sub-view {
  background: white;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.chart-view {
  height: 400px;
  width: 100%;
}
</style>